import * as React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { AdminNewListedBaseTable } from "../@components"
import { useAdminNewListedList } from "../@hooks"
import { adminNewListedSkuMappingData } from "../@signals"


export default function AdminNewListedSkuMappingTable() {
	const { handleCloseSkuMappingTable } = useAdminNewListedList()

	if (!adminNewListedSkuMappingData.value?.length) return <></>

	return <Box id="new-listed-sku-mapping-table">
		<AdminNewListedBaseTable
			title="New Listed Sku Mapped"
			subtitle="List of items behind."
			isSkuMappingTable
			data={adminNewListedSkuMappingData.value}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={handleCloseSkuMappingTable}
					tooltip="Close Table"
				/>
			}}
		/>
	</Box>
}